import { useMutation } from "@tanstack/react-query";
import type { ExtensionArtifactTestInputLoader } from "./extension-artifact-code-editor-modal";

export function useExtensionArtifactTestInput({
  loader,
  onLoaded,
}: {
  loader: ExtensionArtifactTestInputLoader | undefined;
  onLoaded: (input: unknown) => void;
}) {
  return useMutation({
    mutationFn: async (inputKey: string) => {
      if (!loader) {
        throw new Error("No test input loader configured");
      }
      return await loader.load(inputKey);
    },
    onSuccess: onLoaded,
    // Load-by-key is an explicit lookup. Unknown order numbers should fail
    // once, not inherit QueryClient `mutations.retry: 1`.
    retry: false,
  });
}
